export default "__VITE_ASSET__smeFUStL__"